import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import usePageTracking from './hooks/usePageTracking';
import Contact from './pages/Contact';
import Demo from './pages/Demo';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';

function AppShell() {
  usePageTracking();
  return (
    <div className="App flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-grow pt-24 lg:pt-28">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppShell />
      </Router>
    </HelmetProvider>
  );
}

export default App;
